import SiftBreadcrumb from './SiftBreadcrumb'
import SiftConditions from './SiftConditions'
import CourseList from './CourseList'
import QueryKeys from './QueryKeys'
import TeacherSwiper from './TeacherSwiper'
import Teacher from './Teacher'

export default {
  SiftBreadcrumb,
  SiftConditions,
  CourseList,
  QueryKeys,
  TeacherSwiper,
  Teacher
}



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/index.js